import React, { useEffect, useState } from 'react';
import Plot from 'react-plotly.js';

const GanttChart = ({ tasks }) => {
    const [chartData, setChartData] = useState([]);
    const [chartLayout, setChartLayout] = useState({});

    useEffect(() => {
        const startedTasks = tasks.filter(t => t.startDate);
        if (startedTasks.length === 0) {
            setChartData([]);
            return;
        }

        const parentTasks = startedTasks.filter(t => !t.parentId);
        const childTasks = startedTasks.filter(t => t.parentId);

        // Sort parent tasks by their start date
        parentTasks.sort((a, b) => new Date(a.startDate) - new Date(b.startDate));
        
        // Create the final display list, grouping children under their parents
        const displayTasks = [];
        parentTasks.forEach(parent => {
            displayTasks.push(parent);
            const children = childTasks.filter(c => c.parentId === parent.id);
            // Sort children by their start date
            children.sort((a, b) => new Date(a.startDate) - new Date(b.startDate));
            displayTasks.push(...children);
        });

        const now = new Date();

        const data = displayTasks.map(task => {
            const startDate = new Date(task.startDate);
            const endDate = task.endDate ? new Date(task.endDate) : now;
            const isParent = !task.parentId;
            const duration = endDate.getTime() - startDate.getTime(); // Duration in milliseconds

            return {
                base: [startDate], // Set the base of the bar to the start date
                x: [duration], // Set the length of the bar to the duration
                y: [task.id], // Use unique ID for y-axis value
                type: 'bar',
                orientation: 'h',
                name: task.name, 
                hoverinfo: 'text',
                text: `<b>${task.name}</b><br>开始: ${startDate.toLocaleString('zh-CN', { timeZone: 'Asia/Shanghai' })}<br>结束: ${task.endDate ? endDate.toLocaleString('zh-CN', { timeZone: 'Asia/Shanghai' }) : '进行中'}`,
                marker: {
                    color: isParent ? 'rgba(31, 119, 180, 0.8)' : 'rgba(174, 199, 232, 0.8)',
                    line: {
                        color: 'rgba(31, 119, 180, 1)',
                        width: 1
                    }
                }
            };
        });

        const yAxisLabels = displayTasks.map(task => {
            const truncatedName = task.name.length > 9 ? task.name.substring(0, 9) + '...' : task.name;
            return !task.parentId ? `<b>${truncatedName}</b>` : truncatedName;
        });

        const layout = {
            title: '任务甘特图 (UTC+8)',
            height: 200 + data.length * 40,
            showlegend: false,
            xaxis: {
                type: 'date',
                showgrid: true,
                zeroline: true,
                tickformat: '%m-%d %H:%M',
                autorange: true,
                showline: true,
                mirror: 'ticks',
            },
            yaxis: {
                ticktext: yAxisLabels,
                tickvals: displayTasks.map(t => t.id), // Use unique ID for tick values
                autorange: 'reversed',
                tickangle: -45,
                automargin: true,
            },
            barmode: 'relative',
            margin: {
                l: 150,
                r: 50,
                t: 80,
                b: 50,
            }
        };
        
        setChartData(data);
        setChartLayout(layout);

    }, [tasks]); // Re-run effect when tasks change

    if (chartData.length === 0) {
        return null;
    }

    return (
        <div className="gantt-chart-container">
            <Plot
                data={chartData}
                layout={chartLayout}
                config={{ responsive: true }}
                style={{ width: '100%', height: '100%' }}
            />
        </div>
    );
};

export default GanttChart; 